<div #sideMenu *ngrxLet="sharedFacade.isLoaded$ as dataLoaded">
  <ngb-accordion
    class="sidebar-accordion"
    style="overflow: auto"
    [closeOthers]="closeOthers"
    [activeIds]="activeIdsMain"
    (panelChange)="onAccordionChange($any($event))"
    #accordion="ngbAccordion"
    id="reportElement"
  >
    <ngb-panel
      ngbPanelToggle="accordion"
      class="custom-cLass"
      *ngFor="let children of menuItems; let index = index"
      id="panel-main-{{ index }}"
    >
      <ng-template *ngIf="children?.submenu" ngbPanelTitle>
        <img [src]="children.isActive ? children.activeImg : children.icon" alt="scenario" />
        <a
          class="menutext"
          (click)="onParentMenuClick(children, $event)"
          [title]="index == 1 ? 'Products' : 'Report'"
          routerLinkActive="active"
          [routerLinkActiveOptions]="{ exact: true }"
        >
          <span [ngClass]="children.isActive ? 'activeClass' : ''" class="parent-span-submenu">{{
            children.text
          }}</span>
        </a>
      </ng-template>
      <ng-template *ngIf="!children?.submenu" ngbPanelHeader>
        <div class="vert-align">
          <img
            (click)="collapsePanel(children, children.link)"
            [src]="children.isActive ? children.activeImg : children.icon"
            alt="scenario"
          />
          <a
            routerLink="{{ children.link }}"
            class="menutext"
            routerLinkActive="active"
            (click)="collapsePanel(children, children.link)"
          >
            <span class="parent-span-header">{{ children.text }}</span>
          </a>
        </div>
      </ng-template>
      <ng-template ngbPanelContent>
        <ngb-accordion
          class="sidebar-child-accordion"
          [closeOthers]="closeOthers"
          #childaccord="ngbAccordion"
          [activeIds]="activeIdsSub"
        >
          <ngb-panel
            panelClass="custom-panel"
            *ngFor="let children2 of children.submenu; let index2 = index"
            [disabled]="!children2?.submenu"
            id="panel-sub-{{ index2 }}"
            >{{ children2.text }}>
            <ng-template *ngIf="children2?.submenu" ngbPanelTitle>
              <!-- FOR SCENARIO NAMES -->
              <a
                class="dropdown-item iconify text-ellipsis scenario-name"
                routerLinkActive="active"
              >
                <span
                  class="child-span-submenu"
                  [ngClass]="
                    children.isActive &&
                    !currentRoute.includes('product-list') &&
                    children2?.productId == productId
                      ? 'activeScenarioClass'
                      : 'ac'
                  "
                  title="{{ children2.text }}"
                >
                  {{ children2.text }}</span
                >
              </a>
            </ng-template>
            <ng-template *ngIf="!children2?.submenu" ngbPanelHeader>
              <!-- Report submenus -->
              <a
                class="dropdown-item iconify text-ellipsis-report"
                (click)="navigate(children, children2, children2.link, $event)"
              >
                <span
                  [ngClass]="children2.isActive ? 'activeClass' : ''"
                  title="{{ children2.text }}"
                  class="child-span-header"
                  >{{ children2.text }}</span
                >
              </a>
            </ng-template>
            <ng-template *ngIf="children2.submenu" ngbPanelContent>
              <div class="offset-1" *ngFor="let children3 of children2.submenu; let i = index">
                <a
                  class="btn content w-100"
                  routerLink="{{ children3.link }}"
                  routerLinkActive="active"
                  [routerLinkActiveOptions]="{ exact: true }"
                  (click)="navigate(children, children2, children3.link, $event)"
                  [ngClass]="{
                    active: children2.productId == productId && router.url.includes(children3.link)
                  }"
                >
                  <span
                    class="child-span-links"
                    [id]="children3.text.toLowerCase()"
                    title="{{ children3.text }}"
                    >{{ children3.text }}</span
                  ></a
                >
              </div>
            </ng-template>
          </ngb-panel>
        </ngb-accordion>
      </ng-template>
    </ngb-panel>
  </ngb-accordion>
</div>
